import React, { Component } from 'react';
import RUCreationLotsTableList from './UsedRentalsLots/RUCreationLotsTableList';
import DropdownListAPI from '../../../API/DropdownListAPI';
import RULotEditForm from './UsedRentalsEditLots/RULotEditForm';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import { handleServerError } from '../../../Utils/Helper';
import { UR_MODULE } from '../../../Utils/Constants';


export class RUCreationContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      usedRentalsStateList: [],
      creationLot: {},
      shouldReloadList: false,
      showUsedRentalEditForm: false,
      openError: false,
      alertMessage: ''
    };
  }

  componentDidMount() {
    const dropdownListDataAPI = new DropdownListAPI();
    dropdownListDataAPI.getAllLotStates(UR_MODULE, true).then((response) => {
      this.setState({
        usedRentalsStateList: response.data,
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      });
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  openEditLotMainForm(oCreationLot, optionalsDescription) {
    this.setState({
      showUsedRentalEditForm: !this.state.showUsedRentalEditForm,
      creationLot: oCreationLot,
      optionaisDescriptionState: optionalsDescription
    });
  }

  reloadNegotiationLotsTableList() {
    this.setState({ shouldReloadList: true });
  }


  render() {

    return (
      <div>
        <RUCreationLotsTableList
          negotiationLotStateList={this.state.usedRentalsStateList}
          openEditLotMainForm={this.openEditLotMainForm.bind(this)}
          titleNegLot={this.props.titleTableListNegLot}
          titleTableList={this.props.titleTableList}
          shouldReloadList={this.state.shouldReloadList}
          showContent={this.props.showContent}
        />

        {!this.state.creationLot ?
          null :
          <RULotEditForm
            open={this.state.showUsedRentalEditForm}
            reloadNegotiationLotsTableList={this.reloadNegotiationLotsTableList.bind(this)}
            openEditLotMainForm={this.openEditLotMainForm.bind(this)}
          />
        }

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    )
  }
}

export default RUCreationContent;


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsCreation/RUCreationContent.js